import React from 'react'

const Error = ({error}) => {
    return (
        <div className="error-output">
            {error && <div style={{color : 'red'}}>{error}</div>}
        </div> 
    )
}

export default Error
